import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import About from '../components/About';
import Program from '../components/Program';
import Gallery from '../components/Gallery';
import Location from '../components/Location';
import Partners from '../components/Partners';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <div className="min-h-screen bg-black">
      <Header />
      <Hero />
      <About />
      <Program />
      <Gallery />
      <Location />
      <Partners />
      <Contact />
      <Footer />
    </div>
  );
};

export default Home;
